import * as React from "react";

import type { IconProps } from "./types";

export const DropletIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <path
        d="M9.41427 1.764C9.03576 1.22065 8.70179 0.720756 8.39008 0.264335C8.34554 0.199132 8.27875 0.133929 8.21195 0.0904599C7.94477 -0.0834148 7.58853 0.00352253 7.41041 0.264335C7.12097 0.720756 6.78699 1.19891 6.38622 1.764C4.62728 4.28519 2 8.0887 2 10.2621C2 11.8487 2.66795 13.2832 3.73668 14.3265C4.8054 15.348 6.27489 16 7.90024 16C9.52559 16 10.9951 15.348 12.0638 14.3047C13.1325 13.2615 13.8005 11.827 13.8005 10.2404C13.8005 8.06696 11.1732 4.28519 9.41427 1.764ZM11.2623 13.5223C10.3939 14.3699 9.21388 14.8698 7.90024 14.8698C6.5866 14.8698 5.40656 14.3482 4.53822 13.5223C3.66988 12.6746 3.15778 11.5227 3.15778 10.2404C3.15778 8.41471 5.67374 4.78508 7.34362 2.37257C7.544 2.09002 7.72212 1.80747 7.90024 1.5684C8.07836 1.80747 8.25648 2.09002 8.45687 2.37257C10.1268 4.80681 12.6427 8.41471 12.6427 10.2404C12.6427 11.5227 12.1083 12.6746 11.2623 13.5223Z"
        fill={color}
      />
    </svg>
  ),
);

export default DropletIcon;
